import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Modal,
  Typography,
  Button,
  Space,
  Row,
  Col,
  Card,
  Tooltip,
  notification,
  Popover,
  theme,
  Grid
} from "antd"
import "remixicon/fonts/remixicon.css"
import Lottie from "react-lottie"
import starAnimationData from "../../../../data/assets/lotties/rotatingStar.json"
import discountAnimationData from "../../../../data/assets/lotties/discount.json"
import {
  getDataFromLocalStorage,
  setDataInLocalStorage,
} from "../../../../data/utils/index.js"
import {
  currencyMap,
  LOCAL_STORAGE,
  STARTER_LTD_CHECKOUT_SOURCE,
} from "../../../../data/configs/constants.js"
import RenderHtmlOrMarkdown from "../../../components/RenderHtmlOrMarkdown/index.js"
import {
  getManageBillingUrl,
  getPlanInvoicePreview,
} from "../../../../data/store/pageSlice/index.js"
import ErrorBoundary from "../../../components/ErrorBoundary/index.js"
import Timeout from "../../../components/Timeout/index.js"
import { IMG_LOGO_SVG } from "../../../../data/assets/index.js"
import "./index.scss"
import Notify, { notify } from "../../../components/Notify/index.js"



const { Title, Text, Paragraph } = Typography
const { useBreakpoint } = Grid;

const LTDofferDialog = ({
    showLTDoffer,
    setShowLTDoffer,
    ltdOfferData,
    allowPromoCode,
    source = STARTER_LTD_CHECKOUT_SOURCE.EXTERNAL,
    onOfferDecline,
    onOfferAccept,
    customPurchaseLogic = false,
}) => {
  const [popoverVisible, setPopoverVisible] = useState(false)
  const [ltdConfirmWarning, setLtdConfirmWarning] = useState({
    show: false,
  })
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const user = useSelector((state) => state.authDetails.user)
  const dispatch = useDispatch()
  const planType = "one_time"
  const { token: themeToken } = theme.useToken()
  const pricingContents = useSelector(
    (state) => state.billingDetails.pricingTableData
  )

  const itemInfoSubscription = useMemo(() => {
    for (const idx in pricingContents.subscriptionPricingTable) {
      const data = pricingContents.subscriptionPricingTable[idx]
      if (data.isUserSubscribedToProduct === true) {
        return data.itemInfo
      }
    }
    return null
  }, [pricingContents])

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: starAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  const discountData = {
    loop: true,
    autoplay: true,
    animationData: discountAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  const handleDialogClose = () => {
    setShowLTDoffer(false)
    setPopoverVisible(false)
    setDataInLocalStorage(LOCAL_STORAGE.HAS_SEEN_STARTER_LTD, true)
    if (onOfferDecline) onOfferDecline()
  }

  const email = useMemo(() => {
    if (user?.email) {
      const splittedEmail = user.email.split("@")
      const country = getDataFromLocalStorage(LOCAL_STORAGE.COUNTRY, null)
      if (country)
        return (
          splittedEmail[0] + "+location_" + country + "@" + splittedEmail[1]
        )
      return user?.email
    }
    return ""
  }, [user])

  const fetchStripeUrl = (data = {}, forced = false) => {
    let referral = null
    if (window?.Rewardful?.referral) {
      referral = window?.Rewardful?.referral
    }
    dispatch(
      getManageBillingUrl({
        ...data,
        quantity: 1,
        email: email,
        source: "pricing",
        stripeMetadata: {
          referral,
        },
      })
    )
  }

  const showInvoicePreview = (data = {}, discountData, warning) => {
    const payload = {
      customerId: data?.customerId,
      subscriptionId: data?.subscriptionId,
      subscriptionItems: [
        {
          price: data?.pricingId,
          quantity: data?.quantity || 1,
          id: data?.id,
        },
      ],
      subscriptionKey: data?.subscriptionKey,
      discount: {
        couponCode: discountData?.couponCode,
      },
    }
    if (
      data?.isUserSubscribedToPrice &&
      payload?.subscriptionItems[0]?.quantity === data?.defaultQuantity
    ) {
      notify.error({
        message:
          "Please adjust the quantity of the chatbots before proceeding with the upgrade.",
      })
      return
    }
    dispatch(getPlanInvoicePreview(payload))
      .unwrap()
      .then((res) => {
        if (res.status === "success") {
        }
      })
  }

  const hideConfirmWarning = () => {
    setLtdConfirmWarning({
      show: false,
    })
  }

  const showConfirmWarning = (payload) => {
    setLtdConfirmWarning(payload)
  }

  if (!ltdOfferData) return null

  return (
    <>
      <Notify />
      <Modal
        className="orimon-ltd-modal"
        open={showLTDoffer}
        onCancel={handleDialogClose}
        width={900}
        footer={null}
        style={{ padding: 0, overflowY: isMobile? "auto":"hidden",overflowX:"hidden", borderRadius: "8px" }}
        bodyStyle={{ padding: 0 }}
        closable={false}
      >
        <Row style={{ height: isMobile ? "fit-content": "80vh", flexDirection: isMobile ? "row" : "row", }}>
          <Col
            xs={24}
            md={8}
            style={{
              height: isMobile ? "auto" : "100%",
              background:
                "linear-gradient(357.87deg, #000000 19.9%, #454545 102.13%)",
              padding:  isMobile ? "1.5rem 1rem" : "2rem 1rem",
              position: "relative",
              overflow: "hidden",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <div
              style={{
                background: `url(${IMG_LOGO_SVG})`,
                opacity: 0.1,
                position: "absolute",
                width: 1200,
                height: 1200,
                top: -325,
                left: -480,
                filter: "contrast(0)",
                pointerEvents: "none",
                userSelect: "none",
              }}
            />
            <Timeout
              onTimeoutEnd={() => setShowLTDoffer(false)}
              duration={120}
              pulseAfter={30}
            />
          </Col>

          <Col
            xs={24}
            md={16}
            style={{
              padding: isMobile ? "1rem" : "1rem 1.5rem",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Card
              style={{
                borderRadius: 12,
                overflow: "hidden",
                marginBottom: 16,
              }}
              bodyStyle={{ padding: 0 }}
            >
              <div
                style={{
                  background:
                    "linear-gradient(to left, #454545, #000000 19.9%)",
                  color: "white",
                  padding: "8px 0",
                  textAlign: "center",
                  textTransform: "uppercase",
                  fontSize: 14,
                }}
              >
                No Monthly fees !
              </div>

              <Row align="middle" style={{ padding: 16 }}>
                <Col flex="auto">
                  <Title level={5} style={{ margin: 0 }}>
                    Get lifetime access
                  </Title>
                  <Text>to our starter plan for just</Text>
                </Col>
                <Col
                  style={{
                    position: "relative",
                    width: isMobile ? "100%" : "41.67%",
                    padding: isMobile ? "16px 0" : "32px 0",
                  }}
                >
                  <Title
                    level={2}
                    style={{
                      margin: 0,
                      textAlign: "center", // center text
                      width: "100%",
                    }}
                  >
                    {ltdOfferData[planType]?.pricing?.map((_price, idx) => (
                      <span key={idx}>
                        {currencyMap.get(_price.currency)}&nbsp;
                        {_price.displayPrice.toFixed(2).split(".")[0]}
                      </span>
                    ))}
                  </Title>
                  <div
                    style={{
                      position: "absolute",
                      width: "75%",
                      height: "66.67%",
                      left: "13%",
                      top: "15%",
                      transform: "rotate(-12deg)",
                      border: `4px solid ${themeToken.colorPrimary}`,
                      borderRadius: "130px / 60px",
                    }}
                  >
                    <Card
                      style={{
                        position: "absolute",
                        transform: "rotate(12deg)",
                        bottom: -8,
                        left: 20,
                        boxShadow: "none",
                      }}
                      bordered={false}
                      bodyStyle={{
                        padding: 0,
                      }}
                    >
                      <Text delete type="secondary">
                        $49 / month
                      </Text>
                    </Card>
                  </div>
                </Col>
              </Row>
            </Card>

            <Row gutter={[16, 16]} style={{ overflowY: "auto", flex: 1 }}>
              {ltdOfferData[planType]?.features?.map(
                (item, index) =>
                  item.value && (
                    <Col key={index} xs={24} sm={12}>
                      <Card
                        size="small"
                        bordered
                        style={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",
                        }}
                      >
                        <Space>
                          <i
                            className={item.icon}
                            style={{
                              fontSize: 24,
                              padding: "6px",
                              background: "#E2F0FC",
                              borderRadius: 6,
                              color: "black",
                            }}
                          />
                          <div
                            id="plan-feature-wrapper"
                            dangerouslySetInnerHTML={{ __html: item.text }}
                            style={{ fontSize: 14, fontWeight: 600 }}
                          />
                        </Space>
                      </Card>
                    </Col>
                  )
              )}
            </Row>

            <Tooltip
              title={ltdOfferData[planType]?.buttonDisablingInfo?.reason}
            >
              <Button
                type="primary"
                size="large"
                block
                style={{ marginTop: 16 }}
                disabled={ltdOfferData[planType]?.buttonDisablingInfo?.status}
                onClick={() => {
                  if (ltdOfferData[planType]?.confirmStarterLtdWarning)
                    return showConfirmWarning(
                      ltdOfferData[planType]?.confirmStarterLtdWarning
                    )

                  if(customPurchaseLogic){
                      return onOfferAccept()
                  }
                  
                  if (!itemInfoSubscription) {
                      fetchStripeUrl({
                          allowPromoCode: allowPromoCode[ltdOfferData[planType]?.pricing[0].id],
                          pricingId: ltdOfferData[planType]?.pricing[0].id,
                          productName: ltdOfferData?.title,
                          warnings: ltdOfferData[planType]?.warnings,
                          interval: planType,
                          sessionParametersMetadata: {
                              source: source || STARTER_LTD_CHECKOUT_SOURCE.EXTERNAL
                          }
                      })
                  }
                  else {
                      showInvoicePreview({
                          allowPromoCode: allowPromoCode[ltdOfferData[planType]?.pricing[0].id],
                          pricingId: ltdOfferData[planType]?.pricing[0].id,
                          productName: ltdOfferData?.title,
                          warnings: ltdOfferData[planType]?.warnings,
                          interval: planType,
                          customerId: itemInfoSubscription.customerId,
                          subscriptionId: itemInfoSubscription.subscriptionId,
                          id: itemInfoSubscription.id,
                          subscriptionKey: ltdOfferData[planType]?.subscriptionKey,

                      }, discountData)
                  }
                  if(handleDialogClose) handleDialogClose()
                }}
              >
                {ltdOfferData[planType]?.buttonText}
              </Button>
          </Tooltip>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: isMobile ? 12 : 0
            }}
          >
            <Popover
              open={popoverVisible}
              onOpenChange={(open) => setPopoverVisible(open)}
              placement="top"
              overlayInnerStyle={{ padding: 0 }}
              content={
                <Card bordered style={{ maxWidth: 400 }}>
                  <Typography.Text
                    strong
                    style={{
                      display: "block",
                      textAlign: "center",
                      fontSize: "20px",
                    }}
                  >
                    Exclusive Lifetime Offer – Seize the Opportunity
                  </Typography.Text>
                  <Typography.Paragraph
                    style={{ textAlign: "center", marginTop: 8 }}
                  >
                    This limited-time offer grants you access to a lifetime
                    deal that won’t be available again. Don’t miss the chance
                    to secure lasting value and benefits. Act now to take
                    advantage of this exclusive opportunity before it expires.
                  </Typography.Paragraph>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 8,
                      marginTop: 16,
                    }}
                  >
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => setPopoverVisible(false)}
                    >
                      Yes, Secure My Lifetime Deal
                    </Button>
                    <Button danger size="small" onClick={handleDialogClose}>
                      No, Decline the Offer
                    </Button>
                  </div>
                </Card>
              }
              trigger="click"
            >
              <Button
                size="small"
                danger
                type="text"
                style={{ marginTop: 16 }}
                onClick={() => setPopoverVisible(true)}
              >
                I don't want the lifetime deal
              </Button>
            </Popover>
          </div>
          </Col>
        </Row>
      </Modal>
      <ErrorBoundary onErrorCallback={hideConfirmWarning}>
        <Modal
          open={ltdConfirmWarning?.show}
          title="Are you sure you want to proceed?"
          onCancel={hideConfirmWarning}
          footer={[
            <Button key="disagree" onClick={hideConfirmWarning}>
              Disagree
            </Button>,
            <Button
              key="agree"
              type="primary"
              onClick={onOfferAccept}
              autoFocus
            >
              Agree
            </Button>,
          ]}
        >
          <Paragraph>{ltdConfirmWarning?.message}</Paragraph>
        </Modal>
      </ErrorBoundary>
    </>
  )
}

export default LTDofferDialog
